module.exports = __webpack_public_path__ + "img/elder_blademaster_small.b91c2e51.png";